<template>
  <v-row>
    <v-col>
      <!-- <span>contact</span> -->
      <SendMessageForm mode="about" @onSubmit="sendMsg" />
      <AlertModal
              :show="modal"
              :message="modalMsg"
              @onConfirm="modal = false"
      ></AlertModal>
    </v-col>
  </v-row>
</template>

<script>
import SendMessageForm from "../form/SendMessageForm";
import AlertModal from "../modals/AlertModal";
import { mapState } from 'vuex';
export default {
  mounted() {
    this.loadReCAPTCHAScript();
  },
  data: () => ({
    modal: false,
    modalMsg: ''
  }),
  computed: {
    ...mapState({
      branch_id: state => state.Branch.branch_id
    })
  },
  components: {
    SendMessageForm,
    AlertModal
  },
  beforeDestroy() {
    this.$forceUpdate()
    this.$nextTick(() => {
      const script = document.getElementById("recaptcha-script");
      const script_el = document.getElementsByClassName("grecaptcha-badge");
    
      if (script) {
        script.remove()
        script_el[0].remove()
      }
    })
  },
  methods: {
    loadReCAPTCHAScript() {
      if (!document.querySelector("#recaptcha-script")) {
        const script = document.createElement("script");
        script.id = "recaptcha-script";
        script.src = "https://www.google.com/recaptcha/api.js?render=6LdUeYIqAAAAAMb6B1F6t-vGkhzdX9mCSZdeC4c2";
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    },
    async sendMsg(form) {
      
      const siteKey = '6LdUeYIqAAAAAMb6B1F6t-vGkhzdX9mCSZdeC4c2';
      const token = await grecaptcha.execute(siteKey, { action: "submit" });
      form.token = token;

      form.branch_id = this.branch_id;
      if (form.email && form.phone && form.token) {
        this.$store.dispatch('Contact/sendMsgContactBranch', form).then(() => {
          this.modalMsg = this.$t('messageBox.success');
          this.modal = true;
        })
        .catch((error) => {
          console.error('Error:', error);
          this.modalMsg = this.$t('messageBox.error'); 
          this.modal = true;
        });
      } else {
        this.modalMsg = this.$t('messageBox.notValid');
        this.modal = true;
      }
    }
  }
};
</script>

<style>
</style>
